import { useSearchParams } from 'react-router-dom';
import { convertSearch } from 'utils/helpers/searchString';
import {
  GetUserNaimixContractsOrderByEnum,
  OrderDirectionEnum,
  UserContractNaimixStatusEnum,
  UserNaimixContractTypeEnum,
} from 'generated/graphql';
import { useMemo } from 'react';
import { useGetUserNaimixContractsQuery } from './queries/generated/GetUserNaimixContracts';

export const useUserContractsPaginated = () => {
  const [params] = useSearchParams();
  const type = params.get('type');
  const status = params.get('status');
  const createdAt = params.get('createdAt');
  const searchQuery = params.get('search');
  const sortBy = params.get('sortBy');
  const sortWay = params.get('sortWay');
  const pageParam = params.get('page');
  const page = pageParam ? +pageParam : 1;
  const sizeParam = params.get('size');
  const size = sizeParam ? +sizeParam : 25;

  const sortByMap: Record<string, GetUserNaimixContractsOrderByEnum> = {
    lastname: GetUserNaimixContractsOrderByEnum.LastName,
    createdAt: GetUserNaimixContractsOrderByEnum.CreatedAt,
    status: GetUserNaimixContractsOrderByEnum.Status,
    type: GetUserNaimixContractsOrderByEnum.Type,
  };

  const sortWayMap: Record<string, OrderDirectionEnum> = {
    desc: OrderDirectionEnum.Desc,
    asc: OrderDirectionEnum.Asc,
  };

  const {
    data: dataUserContracts,
    loading: loadingUsers,
    error,
  } = useGetUserNaimixContractsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        limit: size,
        offset: (page - 1) * size,
        searchQuery: convertSearch(searchQuery) || undefined,
        status: (status as UserContractNaimixStatusEnum) || undefined,
        type: (type as UserNaimixContractTypeEnum) || undefined,
        orderBy: sortBy ? sortByMap[sortBy] : undefined,
        orderDirection: sortWay ? sortWayMap[sortWay] : undefined,
        createdAt: createdAt || undefined,
      },
    },
  });

  const userContractsPaginated = dataUserContracts?.getUserNaimixContracts;
  const contracts = useMemo(
    () => userContractsPaginated?.userNaimixContracts || [],
    [userContractsPaginated?.userNaimixContracts],
  );
  return { contracts, userContractsPaginated, loadingUsers, error, page };
};
